import { FC } from 'react';

interface DateFilterProps {
    label: string;
    value: string;
    onChange: (value: string) => void;
    disabled?: boolean;
    className?: string;
    max?: string;
    /** id do input; sem ele, sai do próprio rótulo */
    id?: string;
}

/** "Data do pagamento" → "data-do-pagamento" */
const slug = (texto: string) =>
    texto.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '')
        .replace(/[^a-z0-9]+/g, '-').replace(/(^-|-$)/g, '');

const DateFilter: FC<DateFilterProps> = ({ label, value, onChange, disabled = false, className = '', id, max }) => {
    // o rótulo precisa APONTAR para o input: sem isso ele é texto solto ao lado de um campo, e
    // nem leitor de tela nem clique no texto chegam ao controle
    const inputId = id || `date-filter-${slug(label)}`;
    return (
        <div className={`flex items-center gap-2 ${className}`}>
            <label htmlFor={inputId} className="text-sm font-medium text-gray-700 dark:text-gray-300">
                {label}
            </label>
            <input
                id={inputId}
                type="date"
                max={max}
                value={value}
                onChange={(e) => onChange(e.target.value)}
                disabled={disabled}
                className="px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-md text-sm bg-white dark:bg-gray-700 text-gray-900 dark:text-white focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 disabled:opacity-50 disabled:cursor-not-allowed"
            />
        </div>
    );
};

export default DateFilter;
